export enum AppRoutes {
  MAIN = 'main',
  LOGIN = 'login',
  INDIA_LANDING = 'india_landing',
  RUSSIA_LANDING = 'russia_landing',
  RUSSIA_ONBOARDING_SUCCESS = 'russia_onboarding_success',
  RUSSIA_EXISTING_ACCOUNT = 'russia_existing_account',
  SETUP = 'setup',
  SIGN_UP = 'sign_up',
  SUCCESSFUL_PAYMENT = 'successful_payment',
  OTP_CHECK = 'otp_check',
  TEST = "test",
  STRIPE_CALLBACK = "stripe",

  // last
  NOT_FOUND = 'not_found',
}

export const getRouteMain = () => `/`;
export const getRouteConnections = () => `/connections`;
export const getRoutePayment = () => `/payment`;
export const getRouteSupport = () => `/support`;
export const getRouteLogin = () => `/login`;
export const getRouteIndiaLanding = () => `/in`;
export const getRouteRussiaLanding = () => `/ru`;
export const getRouteRussiaOnboardingSuccess = () => `/ru/onboarding`;
export const getRouteRussiaExistingAccount = () => `/ru/registered`;
export const getRouteSetup = () => `/setup`;
export const getSignUp = () => `/sign-up`;
export const getRouteSuccessfulPayment = () => `/successful-payment`;
export const getRouteOtpCheck = () => `/otpcheck`;
export const getRouteTest = () => undefined //`/test`;
export const getRouteStripeCallback = () => `/callback/stripe`;
